import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { Observable } from "rxjs";
import { PageConfiguration } from "../../../../models/page-configuration";

@Component({
  selector: "app-modal-wrapper",
  templateUrl: "./modal-wrapper.component.html",
  styleUrls: ["./modal-wrapper.component.scss"],
})
export class ModalWrapperComponent implements OnInit {
  @Input() isHotelPromotion: boolean;
  @Input() promotionAlias: string;
  Guid: string;
  localStrings: Array<any>;
  dealers$: Observable<any>;
  CountryID: number;
  AdditionalFieldsFormID: number;
  pageConfig: PageConfiguration;
  message: String;

  dealerCode: string | null;

  modalName: string;

  @Output() openRequestInfoModal = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}
  openRequestInfo(Code: string) {
    this.openRequestInfoModal.emit(Code);
  }
}
